<template>
  <div
    class="hub-app-bar-container flex-grow-0 flex-shrink-0"
    :class="!dialog ? `fixed safe-area-padding-top` : ``"
    :style="appBarContainerStyles"
    v-scroll:#scroll-target="onScroll"
  >
    <div ref="app-bar" class="hub-app-bar" :class="!dialog ? `safe-area-padding-top` : ``">
      <div
        class="hub-app-bar-background"
        :style="appBarStyles"
        :class="color || 'primary darken-1'"
      ></div>
      <div class="hub-app-bar-content" :class="$platform">
        <transition name="scale-transition" origin="center center">
          <slot name="actions-left"></slot>
        </transition>
        <v-spacer />
        <transition name="scale-transition" origin="center center">
          <slot name="actions-right"></slot>
        </transition>
      </div>
      <div class="hub-app-bar-title" :style="appBarTitleStyles">
        <v-slide-x-reverse-transition
          origin="center center"
          hide-on-leave
          >
          <div v-if="titleIndex === 0" :key="`title1`" class="max-width-100">
            <div style="display: flex;" class="flex-column align-center">
              <hub-avatar v-if="titles[0].avatarType" :image-id="titles[0].avatarId" :direct="avatarDirect" :type="titles[0].avatarType" :image-from="titles[0].avatarFrom" :color="titles[0].avatarColor" :date="avatarDate" :size="appBarAvatarSize" :image-size="120" :style="appBarAvatarStyles" />
              <p class="ma-0 text-truncate max-width-100 px-2">
                {{ titles[0].title }}
              </p>
            </div>
          </div>
          <div v-else-if="titleIndex === 1" :key="`title2`">
            <div style="display: flex;" class="flex-column align-center">
              <hub-avatar v-if="titles[1].avatarType" :image-id="titles[1].avatarId" :direct="avatarDirect" :type="titles[1].avatarType" :image-from="titles[1].avatarFrom" :color="titles[1].avatarColor" :date="avatarDate" :size="appBarAvatarSize" :image-size="120" :style="appBarAvatarStyles" />
              <p class="ma-0 text-truncate max-width-100 px-2">
                {{ titles[1].title }}
              </p>
            </div>
          </div>
        </v-slide-x-reverse-transition>
      </div>
      <div id="hub-app-bar-extension" class="hub-app-bar-extension px-4" :style="appBarExtensionStyles" v-show="$slots.extension">
        <slot name="extension"></slot>
      </div>
    </div>
    <p class="text-h4 white--text ma-0" v-if="!hideTitle">
      {{ title }}
    </p>
    <div class="my-2" v-show="$slots.extension && !hideTitle">
      <slot name="extension"></slot>
    </div>
  </div>
</template>

<script>
import HubAvatar from './HubAvatar.vue';

//consts
const AVATAR_SIZE_MAX = 120;
const AVATAR_SIZE_MIN = 40;
const AVATAR_MARGIN_TOP_MAX = 22;
const AVATAR_MARGIN_TOP_MIN = 2;
const AVATAR_MARGIN_BOTTOM_MAX = 12;
const AVATAR_MARGIN_BOTTOM_MIN = 4;


export default {
  props: {
    title: String,
    avatarId: String,
    avatarType: String,
    avatarFrom: String,
    avatarColor: String,
    avatarDirect: Boolean,
    persistent: Boolean,
    dialog: Boolean,
    hideTitle: Boolean,
    color: String,
    loading: Boolean,
    static: Boolean,
  },
  components: {HubAvatar},
  data: () => ({
    currentScroll: 0,
    currentThreshold: 0,
    isActive: false,
    isScrollingUp: false,
    previousScroll: 0,
    savedScroll: 0,
    titleIndex: 0,
    titles: [{}, {}],
    avatarDate: (new Date()).getTime(),
    renderDate: (new Date()).getTime(),
    extensionSlotElement: null,
  }),
  watch: {
    isScrollingUp() {
      this.savedScroll = this.savedScroll || this.currentScroll;
    },
    isActive() {
      this.savedScroll = 0;
    },
    title(val, prev) {
      if (!this.loading && val !== prev) {
        this.setTitle(val, this.avatarId, this.avatarType, this.avatarFrom, this.avatarColor);
      }
    },
    extensionSlot(val) {
      if(val) {
        setTimeout(() => {
          // console.log("extensionSlot added");
          this.renderDate = (new Date()).getTime();
        }, 1);
      }
    }
  },
  computed: {
    extensionSlot() {
      return this.$slots.extension;
    },
    extensionSlotHeight() {
      if(this.renderDate && this.extensionSlot && this.extensionSlotElement) return this.extensionSlotElement.getBoundingClientRect().height;
      return 0;
    },
    currentTitle() {
      return this.titles[this.titleIndex];
    },
    canScroll() {
      return typeof window !== "undefined" && !this.persistent;
    },
    computedScrollThreshold() {
      return this.scrollThreshold ? Number(this.scrollThreshold) : 300;
    },
    appBarContainerStyles() {
      // console.log("baseHeight", this.baseHeightMax);
      if(this.dialog) return {
        marginTop: `0px`
      }

      return {
        marginTop: `${this.baseHeightMax}px`
      };
    },
    appBarStyles() {
      let threshold = 44 / 2;
      let remaining = threshold - this.currentScroll;
      if (remaining < 0) remaining = 0;

      let multiplier = 1 - remaining / threshold;

      return {
        opacity: this.persistent || this.currentTitle.avatarType ? 1 : multiplier,
      };
    },
    baseHeightMin() {
      if(this.currentTitle.avatarType) return AVATAR_SIZE_MIN + AVATAR_MARGIN_TOP_MIN + AVATAR_MARGIN_BOTTOM_MIN + 10 + 24 + (this.$slots.extension ? -10 + this.extensionSlotHeight : 0);
      if(this.persistent) return 44 + (this.$slots.extension ? -10 + this.extensionSlotHeight : 0);
      return 44;
    },
    baseHeightMax() {
      // const BASE_HEIGHT = 44;
      // console.log("this.$slots.extension", this.$slots.extension);
      // if(!this.currentTitle.avatarType) return BASE_HEIGHT;
      if(this.currentTitle.avatarType && !this.persistent) return AVATAR_SIZE_MAX + AVATAR_MARGIN_TOP_MAX + AVATAR_MARGIN_BOTTOM_MAX + 10 + 48 + (this.$slots.extension ? -10 + this.extensionSlotHeight : 0);
      return this.baseHeightMin;
    },
    scaleFactor() {
      let diff = this.baseHeightMax - this.baseHeightMin;
      let scale = 1 - (this.currentScroll / diff);
      if(scale < 0) scale = 0;

      return Math.round((scale + Number.EPSILON) * 100) / 100;
    },
    appBarTitleStyles() {
      let threshold = this.baseHeightMin;

      return {
        opacity: this.persistent || this.currentTitle.avatarType
          ? 1
          : threshold - this.currentScroll <= 0
          ? 1
          : 0,
        paddingBottom: this.currentTitle.avatarType ? (this.$slots.extension ? "0px" : "10px") : "0px",
        fontSize: this.currentTitle.avatarType ? (this.persistent ? "1em" : (1 + this.scaleFactor) + "em") : "inherit"
      };
    },
    appBarExtensionStyles() {
      let threshold = this.baseHeightMin;

      return {
        opacity: this.persistent || this.currentTitle.avatarType
          ? 1
          : threshold - this.currentScroll <= 0
          ? 1
          : 0,
        paddingBottom: this.currentTitle.avatarType ? (this.$slots.extension ? "0px" : "10px") : "0px",
        pointerEvents: this.persistent || this.currentTitle.avatarType
          ? 'initial'
          : threshold - this.currentScroll <= 0
          ? 'initial'
          : 'none'
      };
    },
    appBarAvatarSize() {
      if(this.persistent) return AVATAR_SIZE_MIN;

      const AVATAR_SIZE_DIFF = AVATAR_SIZE_MAX - AVATAR_SIZE_MIN;
      return AVATAR_SIZE_MIN + (AVATAR_SIZE_DIFF * this.scaleFactor);
    },
    appBarAvatarStyles() {
      if(this.persistent) return { marginTop: `${AVATAR_MARGIN_TOP_MIN}px`, marginBottom: `${AVATAR_MARGIN_BOTTOM_MIN}px` };

      const AVATAR_MARGIN_TOP_DIFF = AVATAR_MARGIN_TOP_MAX - AVATAR_MARGIN_TOP_MIN;
      const AVATAR_MARGIN_BOTTOM_DIFF = AVATAR_MARGIN_BOTTOM_MAX - AVATAR_MARGIN_BOTTOM_MIN;

      return { marginTop: `${AVATAR_MARGIN_TOP_MIN + (AVATAR_MARGIN_TOP_DIFF * this.scaleFactor)}px`, marginBottom: `${AVATAR_MARGIN_BOTTOM_MIN + (AVATAR_MARGIN_BOTTOM_DIFF * this.scaleFactor)}px` };
    }
  },
  methods: {
    onScroll(e) {
      if (!this.canScroll) return;

      this.previousScroll = this.currentScroll;
      this.currentScroll = e.target ? e.target.scrollTop : window.pageYOffset;

      this.isScrollingUp = this.currentScroll < this.previousScroll;
      this.currentThreshold = Math.abs(
        this.currentScroll - this.computedScrollThreshold
      );

      // console.log("currentScroll", this.currentScroll);

      this.$nextTick(() => {
        if (
          Math.abs(this.currentScroll - this.savedScroll) >
          this.computedScrollThreshold
        )
          this.thresholdMet();
      });
    },
    thresholdMet() {
      // console.log("Threshold met!");
    },
    setTitle(title, avatarId, avatarType, avatarFrom, avatarColor) {
      let index = this.static ? 0 : this.titleIndex + 1;
      if (index > 1) index = 0;
      this.$set(this.titles, index, {
        title,
        avatarId,
        avatarType,
        avatarFrom,
        avatarColor
      });
      // this.titles[index] = {
      //   title,
      //   avatarId,
      //   avatarType,
      //   avatarColor
      // };
      this.titleIndex = index;

      if(avatarId) this.avatarDate = (new Date()).getTime();

      // console.log(`Set ${index} to '${title}'`);
    },
    updateTitle({title, avatarId, avatarFrom, avatarColor} = {}) {
      this.titles[this.titleIndex].title = title || this.titles[this.titleIndex].title;
      this.titles[this.titleIndex].avatarId = typeof avatarId !== 'undefined' ? avatarId : this.titles[this.titleIndex].avatarId;
      this.titles[this.titleIndex].avatarFrom = avatarFrom || this.titles[this.titleIndex].avatarFrom;
      this.titles[this.titleIndex].avatarColor = avatarColor || this.titles[this.titleIndex].avatarColor;

      if(typeof avatarId !== 'undefined') this.avatarDate = (new Date()).getTime();
    },
  },
  created() {},
  async mounted() {
    this.setTitle(this.title, this.avatarId, this.avatarType, this.avatarFrom, this.avatarColor);
    this.extensionSlotElement = document.getElementById("hub-app-bar-extension");
  },
  beforeDestroy() {
    //cleanup
  },
};
</script>

<style lang="scss">
.hub-app-bar-container {
  .hub-app-bar {
    position: relative;
    left: 0;
    top: 0;
    right: 0;
    z-index: 1;
    pointer-events: none;

    div.hub-app-bar-background {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border-bottom: solid 1px rgba(255, 255, 255, 0.1) !important;
      box-sizing: border-box;
    }

    .hub-app-bar-title {
      position: relative;
      min-width: 100%;
      max-width: 100%;
      min-height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-weight: 600;
      color: white;
      transition: 200ms linear opacity;
      pointer-events: none;
      overflow: hidden;
    }

    .hub-app-bar-extension {
      position: relative;
      min-width: 100%;
      max-width: 100%;
      min-height: 48px;
      display: flex;
      align-items: top;
      justify-content: center;
      color: white;
      transition: 200ms linear opacity;
      overflow: hidden;
    }

    .hub-app-bar-content {
      position: absolute;
      min-width: 100%;
      max-width: 100%;
      max-height: 44px;
      min-height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      pointer-events: initial;

      &.macintosh,
      &.web {
        -webkit-app-region: drag;

        div, button {
          -webkit-app-region: none;
        }
      }
    }
  }

  &.fixed {
    .hub-app-bar {
      position: fixed;
    }
  }
}
</style>
